/* eslint-disable camelcase */
import ABCyaPhaser from '@abcya/abcya_phaser';
import ABCyaLib from '@abcya/abcya_lib';
import Phaser from 'phaser';
import SideTray from '../game/SideTray';
import MenuPopup from '../ui/MenuPopup';
import UIAssetKeys from '../UIAssetKeys';
import DrawingArea from '../game/DrawingArea';
import { printSave } from '../game/savePrint';

export default class Game extends Phaser.Scene {
  static get KEY() { return 'Game'; }

  init() {
    this.input.on(Phaser.Input.Events.GAME_OUT, (time, event) => {
      if (event instanceof MouseEvent) {
        this.input.manager.onMouseUp(event);
      }
    });
  }

  create() {
    this.mid = ABCyaPhaser.Scene.getScreenMidPoint(this);

    this.background = ABCyaPhaser.Images.addImage(0, 0, 'background', this).setOrigin(0);

    this.addDrawingBoard();
    this.addButtons();
  }

  addButtons() {
    this.buttonTray = new SideTray(this);
    this.add.existing(this.buttonTray);

    this.buttonTray.on('MENU_OPEN', () => {this.menuButtonSelected();});
    this.buttonTray.on('MENU_CLOSE', () => {this.menuButtonDeselected();});
    this.buttonTray.on('UNDO_CLICKED', () => {this.undoAction();});
    this.buttonTray.on('ERASER_ON', () => {this.eraseButtonSelected();});
    this.buttonTray.on('BUCKET_ON', () => {this.bucketButtonSelected();});
    this.buttonTray.on('BRUSH_ON', () => {this.brushButtonSelected();});
    this.buttonTray.on('GRID_CLICKED', (optionNumber) => {this.gridButtonOptionSelected(optionNumber);});
    this.buttonTray.on('SIZE_CLICKED', (optionNumber) => {this.sizeButtonOptionSelected(optionNumber);});
    this.buttonTray.on('COLOR_CLICKED', (color) => {this.colorOptionSelected(color);});

    this.buttonTray.initTray();
  }

  menuButtonSelected() {
    console.log('menu button ON ');

    this.menuButtonDialog = new MenuPopup(this);
    this.add.existing(this.menuButtonDialog);
    this.menuButtonDialog.x = this.mid.x + 60;
    this.menuButtonDialog.y = this.mid.y;

    this.drawingArea.drawingDisabled = true;

    this.menuButtonDialog.once('SAVE_CLICKED', () => { this.saveAction(); });
    this.menuButtonDialog.once('PRINT_CLICKED', () => { this.printAction(); });
    this.menuButtonDialog.once('RESET_CLICKED', () => { this.clearAction(); });
    this.menuButtonDialog.once('EXIT_CLICKED', () => { this.cancelAction(); });
  }

  menuButtonDeselected() {
    console.log('menu button OFF ');

    this.buttonTray.resetBtns(false);
    this.buttonTray.toggleBtns(true);

    this.drawingArea.drawingDisabled = false;

    this.menuButtonDialog.off('SAVE_CLICKED');
    this.menuButtonDialog.off('PRINT_CLICKED');
    this.menuButtonDialog.off('RESET_CLICKED');
    this.menuButtonDialog.off('EXIT_CLICKED');

    this.menuButtonDialog.destroy();
  }

  addDrawingBoard() {
    this.artFrame = ABCyaPhaser.Images.addImage(this.scale.width / 2 + 55, this.scale.height / 2, UIAssetKeys._art_area, this);

    this.drawingArea = new DrawingArea(this);
    this.drawingArea.setPosition(this.scale.width / 2 + 55, this.scale.height / 2);

    this.add.existing(this.drawingArea);
  }

  colorOptionSelected(color) {
    this.drawingArea.strokeColor = color;
  }

  sizeButtonOptionSelected(optionNumber) {
    console.log(`size button option = ${optionNumber}`);

    let strokeSize = 2;
    switch (optionNumber) {
      case 1:
        strokeSize = 2;
        break;

      case 2:
        strokeSize = 4;
        break;

      case 3:
        strokeSize = 8;
        break;
    }

    this.drawingArea.strokeSize = strokeSize;
  }

  eraseButtonSelected() {
    console.log('erase button ON ');
    this.drawingArea.tool = 'eraser';
  }

  bucketButtonSelected() {
    console.log('bucket button ON ');
    this.drawingArea.tool = 'bucket';
  }

  brushButtonSelected() {
    console.log('brush button ON ');
    this.drawingArea.tool = 'brush';
  }

  gridButtonOptionSelected(optionNumber) {
    console.log(`grid button option = ${optionNumber}`);

    this.drawingArea.gridOption = optionNumber;

    switch (optionNumber) {
      case 1:
        this.addBothLines();
        break;

      case 2:
        this.addHorizontalLine();
        break;

      case 3:
        this.addVerticalLine();
        break;
    }
  }

  addVerticalLine() {
    if (this.verticalLine) this.verticalLine.destroy();
    if (this.horizontalLine) this.horizontalLine.destroy();

    this.verticalLine = ABCyaPhaser.Images.addImage(0, 0, UIAssetKeys._vertical_line, this);
    this.children.moveBelow(this.verticalLine, this.buttonTray);

    const drawingWidthCenter = this.drawingArea.getBounds().width / 2;

    this.verticalLine.x = this.drawingArea.x + drawingWidthCenter - this.drawingArea.getBounds().width / 2;
    this.verticalLine.y = this.drawingArea.y - 0;
  }

  addHorizontalLine() {
    if (this.verticalLine) this.verticalLine.destroy();
    if (this.horizontalLine) this.horizontalLine.destroy();

    this.horizontalLine = ABCyaPhaser.Images.addImage(0, 0, UIAssetKeys._horizontal_line, this);
    this.children.moveBelow(this.horizontalLine, this.buttonTray);

    const drawingHeightCenter = this.drawingArea.getBounds().height / 2;

    this.horizontalLine.x = this.drawingArea.x - 0;
    this.horizontalLine.y = this.drawingArea.y + drawingHeightCenter - this.drawingArea.getBounds().height / 2;
  }

  addBothLines() {
    if (this.verticalLine) this.verticalLine.destroy();
    if (this.horizontalLine) this.horizontalLine.destroy();

    this.horizontalLine = ABCyaPhaser.Images.addImage(0, 0, UIAssetKeys._horizontal_line, this);
    this.verticalLine = ABCyaPhaser.Images.addImage(0, 0, UIAssetKeys._vertical_line, this);
    this.children.moveBelow(this.horizontalLine, this.buttonTray);
    this.children.moveBelow(this.verticalLine, this.buttonTray);

    const drawingWidthCenter = this.drawingArea.getBounds().width / 2;
    const drawingHeightCenter = this.drawingArea.getBounds().height / 2;

    this.verticalLine.x = this.drawingArea.x + drawingWidthCenter - this.drawingArea.getBounds().width / 2;
    this.verticalLine.y = this.drawingArea.y - 0;

    this.horizontalLine.x = this.drawingArea.x - 0;
    this.horizontalLine.y = this.drawingArea.y + drawingHeightCenter - this.drawingArea.getBounds().height / 2;
  }

  undoAction() {
    this.drawingArea.undoAction();
  }

  saveAction() {
    this.menuButtonDeselected();
    printSave('save', this.drawingArea);
  }

  printAction() {
    this.menuButtonDeselected();
    printSave('print', this.drawingArea);
  }

  clearAction() {
    this.scene.start();
  }

  cancelAction() {
    this.menuButtonDeselected();
  }
}